/**
 * 万里汇合作落地页 —— 内联 SVG 图标集
 *
 * 需求来源：docs/万里汇合作落地页/万里汇合作落地页-提示词.md 第1次提交（任务单 DEV-124229）。
 *
 * 注意事项：
 * 1. 原型共 19 处内联 <svg>，去重后仅 8 种，此处按用途各收一个组件复用。
 *    描边颜色/线宽等由各区块 CSS 控制（原型即如此，svg 自身不带 stroke 属性），故这里只保留
 *    viewBox 与 path，不硬写 stroke —— 硬写会盖掉区块配色。
 * 2. 图标是纯装饰，统一 aria-hidden，避免读屏器把 path 念出来；语义由相邻文本承担。
 */
import React from 'react';

/** 勾选（16×16）—— §1 Hero 三条 benefit、§3 Step2 二选一、§7 Q09 安全标记，共 3 处 */
export function IconCheck() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="m3 8.2 3 3L13 4.5" />
    </svg>
  );
}

/** 右箭头（18×18）—— §1 Hero 主 CTA 按钮 */
export function IconArrowRightLg() {
  return (
    <svg viewBox="0 0 18 18" aria-hidden="true">
      <path d="M4 9h10M10 5l4 4-4 4" />
    </svg>
  );
}

/** 锁（16×16）—— §1 Hero 仪表盘 Secure 标记 */
export function IconLock() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <rect x="3" y="7" width="10" height="7" rx="2" />
      <path d="M5.5 7V5.5A2.5 2.5 0 0 1 8 3a2.5 2.5 0 0 1 2.5 2.5V7" />
    </svg>
  );
}

/** 右箭头（16×16，短杆）—— §1 Hero 仪表盘交易流水图标 */
export function IconArrowRightSm() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 8h10M9 4l4 4-4 4" />
    </svg>
  );
}

/** 右箭头（24×24，双 path）—— §3 步骤连接箭头、§5 卡片箭头等，原型出现 5 次 */
export function IconArrowLong() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14" />
      <path d="m14 7 5 5-5 5" />
    </svg>
  );
}

/** 右箭头（16×16，双 path）—— 各区块按钮尾部小箭头，原型出现 6 次 */
export function IconArrowBtn() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 8h9" />
      <path d="m9 5 3 3-3 3" />
    </svg>
  );
}

/** 左尖角（24×24）—— §6 轮播上一张 */
export function IconChevronLeft() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

/** 右尖角（24×24）—— §6 轮播下一张 */
export function IconChevronRight() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}
